<template>
  <div>
    <el-dialog class="mazhenguo" title="实时画面" :close-on-click-modal="false" @close="resetDlg" :visible.sync="dlgState" append-to-body
      width="600px" top="30px">
      <div id="graphics" style="width: 550px; margin: 0 auto"></div>
      <div style="position: relative;">
        <div class="countdown" :class="{ 'warning': countdown < 10 }">{{ formattedCountdown }}</div>
        <el-tooltip class="item" effect="dark" :content="isSpeak ? '停止对讲' : '开始对讲'" placement="top">
          <!-- @mousemove="move" @mousedown.native="gmousedown" @mouseup="gmouseup" -->
          <div id="myElement" @click="openVerifyPasswordDlg"
            style="position: absolute;top: 20px;right: 90px;display: inline-block;">
            <img v-if="!isSpeak" src="/static/image/noSpeak.png" alt="" />
            <img v-if="isSpeak" src="/static/image/speak.png" alt="" />
          </div>
        </el-tooltip>
        <!-- <el-button type="primary">语音</el-button> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDlg" icon="el-icon-back">返回</el-button>
      </div>
    </el-dialog>

    <el-dialog class="mazhenguo" title="确认密码" :close-on-click-modal="false" :visible.sync="verifyPasswordDlg"
      append-to-body width="700px" top="30px">
      <el-form ref="passwordDlgForm" :rules="passwordDlgRules" :model="passwordDlgData" label-position="right"
        label-width="90px" size="mini" @submit.native.prevent>
        <el-form-item label="输入密码" prop="password">
          <el-input show-password type="password" v-model="passwordDlgData.password" placeholder="请输入输入密码" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="verifyPasswordDlg = false" icon="el-icon-close">关闭</el-button>
        <el-button type="success" @click="submitForm" icon="el-icon-check">
          <span>提交</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 组件
// import Tinymce from '@/components/Tinymce' // 富文本组件
// 工具
// import { phoneReg } from '@/utils/regUtil'
import { uploadImg, uploadImg2 } from "@/utils/uploadImg";
// 接口
// 接口
import { reSampleAndEncodeAudioData } from '@/utils/encode.js'
import { checkPassword } from "@/api/safetyMonitoringApi";
import { communityPage } from "@/api/communityMan";
import { payFeeConfigPage } from "@/api/costMan";
import { postAction, getAction } from "@/api";
import { QNRTPlayer } from "qn-rtplayer-web";
let player = new QNRTPlayer();
let passwordDataEmpty = {
  password: ""
};
let timer = null;
const maxCountdown = 120;
export default {
  components: {
    // Tinymce,
    QNRTPlayer
  },
  props: {
    dlgState0: {
      type: Boolean,
      default: false
    },
    dlgQuery: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ratio() {
      // 不太可能出现这种情况，常见的音频设备采样率是 48k 44.1k
      if (!this.audioContext || this.audioContext.sampleRate < 8000) {
        return 1;
      }
      return Math.floor(this.audioContext.sampleRate / 8000);
    },
    formattedCountdown() {
        const m = Math.floor(this.countdown / 60);
        const s = Math.floor(this.countdown % 60);

        const mm = String(m).padStart(2, '0');
        const ss = String(s).padStart(2, '0');

        return `${mm}:${ss}`
    }
  },
  watch: {
    dlgState0(val) {
      this.dlgState = val;
    },
    dlgState(val) {
      if (val) {
        setTimeout(() => {
          this.$nextTick(() => {
            player.init({});
            player.play(
              `webrtc://qvs-live.webrtc.wlines.cn:447/${this.dlgQuery.qiniuNamespaceId}/${this.dlgQuery.qiniuDeviceId}`,
              document.getElementById("graphics")
            );
            player.setConfig({ controls: true, playsinline: true });
            player.on('playerStateChanged', (state) => {
              if (state === 3) {
                if (timer) {
                  clearInterval(timer)
                }
                this.startTime = new Date().getTime()
                timer = setInterval(() => {
                  const duration = (new Date().getTime() - this.startTime) / 1000
                  const tmpCountdown = maxCountdown - duration
                  this.countdown = tmpCountdown > 0 ? tmpCountdown : 0
                  if (this.countdown === 0) {
                    this.closeDlg()
                    this.countdown = maxCountdown
                  }
                }, 100)
              }
            })
            console.log(player, 'player====');
          });
          console.log(this.dlgQuery, "dlgQuery");
        }, 50);
      } else {
        this.$emit("closeDlg");
      }
    }
  },
  data() {
    return {
      userInfo: "",
      // 弹窗
      dlgState: false,
      dlgLoading: false,
      dlgData: {},

      dlgSubLoading: false, // 提交loading
      isSpeak: false,
      verifyPasswordDlg: false,
      passwordDlgData: JSON.parse(JSON.stringify(passwordDataEmpty)), // 初始化数据
      passwordDlgRules: {
        password: [{ required: true, message: "必填字段", trigger: "input" }], // 设备名称
        conformPassword: [
          { required: true, message: "必填字段", trigger: "blur" }
        ]
      },
      audioSourceNode: "",
      audioContext: "",
      processorNode: "",
      mediaStream: "",
      dataList: [],
      urlData: '',
      startTime: null,
      countdown: maxCountdown
    };
  },
  created() {
    console.log("window.localStorage.userInfo", window.localStorage.userInfo);
    this.userInfo = JSON.parse(window.localStorage.userInfo);
    console.log(this.userInfo);
    // this.getDataDict()
  },
  methods: {
    getMediaStream() {
      console.log(navigator.mediaDevices, "navigator");
      // 大部分浏览器有安全限制，http 协议访问的页面 navigator.mediaDevices 也是 undefined， 仅提供 https 服务的可以忽略这个问题
      if (!navigator.mediaDevices) {
        return Promise.reject(
          "您的浏览器不支持获取用户设备，无法使用对讲功能，建议使用 Chrome 浏览器 ( 版本 >= 74 )"
        );
      }
      return navigator.mediaDevices
        .getUserMedia({ audio: true })
        .catch(() =>
          Promise.reject(
            "请确保录音设备正常，并允许浏览器获取录音权限，否则无法使用对讲功能"
          )
        );
    },
    async makeAudioContextRunning() {
      if (!this.audioContext || this.audioContext.state === "closed") {
        this.audioContext = new AudioContext();
      }
      if (this.audioContext.state === "suspended") {
        await this.audioContext.resume();
      }
    },
    async startRecord() {
      this.audioContext = new AudioContext();
      this.mediaStream = await this.getMediaStream();
      await this.makeAudioContextRunning();
      try {
        this.audioSourceNode = this.audioContext.createMediaStreamSource(
          this.mediaStream
        );
        // 只采集单声道方便处理数据
        this.processorNode = this.audioContext.createScriptProcessor(4096, 1, 1);
        console.log(this.processorNode, 'this.processorNode');
        console.log(this.audioSourceNode.connect(this.processorNode), '====');
        this.audioSourceNode.connect(this.processorNode);
        // sampleRate = 8k & bufferSize = 4096 => 每 0.512s 触发一次 onaudioprocess
        // console.log(this.onAudioProcess(),'onAudioProcess');
        this.processorNode.onaudioprocess = this.onAudioProcess;
        this.processorNode.connect(this.audioContext.destination);
      } catch (e) {
        console.log(e, '======');
        throw new Error(
          "您的浏览器音频相关接口异常，无法使用对讲功能，建议使用 Chrome 浏览器 ( 版本 >= 74 )"
        );
      }
    },
    onAudioProcess(event) {
      let channelData = event.inputBuffer.getChannelData(0);
      this.dataList.push(channelData.slice());
      // 每 (bufferSize * ratio / audioContext.sampleRate ～ bufferSize / audioSampleRate = 4096 / 8k = 0.512s) 发送一次数据
      if (this.dataList.length >= this.ratio) {
        this.sendAudioData(this.dataList);
        this.dataList = [];
      }
    },
    sendAudioData(dataList) {
      let base64Audio = reSampleAndEncodeAudioData(dataList, 4096, this.ratio);
      let listQuery = {
        url: this.urlData,
        base64_pcm: base64Audio
      };
      this.talkFun(listQuery);
      console.log(base64Audio);
    },
    talkFun(listQuery) {
      postAction(`/iot/qiniu/sendAudioData`, listQuery).then(res => {
        console.log(res, 'res');
      })
    },
    releaseResources() {
      if (this.dataList.length > 0) {
        this.sendAudioData(this.dataList);
        this.dataList = [];
      }
      if (this.audioSourceNode) {
        this.audioSourceNode.disconnect();
      }
      if (this.processorNode) {
        this.processorNode.disconnect();
      }
      if (this.mediaStream) {
        this.mediaStream.getAudioTracks().forEach(track => track.stop());
      }
    },
    openVerifyPasswordDlg() {
      if (this.isSpeak) {
        this.isSpeak = !this.isSpeak;
        this.releaseResources();
      } else {
        this.passwordDlgData = JSON.parse(JSON.stringify(passwordDataEmpty));
        this.$nextTick(() => {
          this.$refs["passwordDlgForm"].clearValidate();
        });
        this.verifyPasswordDlg = true;
      }
    },
    voiceFn() {
      let namespaceId = this.dlgQuery.qiniuNamespaceId;
      let deviceId = this.dlgQuery.qiniuDeviceId;
      postAction(
        `/iot/qiniu/v1/namespaces/${namespaceId}/devices/${deviceId}/talk`
      ).then(res => {
        if (
          res.data.data.audioSendAddrForHttp &&
          res.data.data.audioSendAddrForHttp != null &&
          res.data.data.audioSendAddrForHttp != ""
        ) {
          this.urlData = res.data.data.audioSendAddrForHttp;
          this.startRecord();
        }
      });
    },
    isIntercom() {
      this.isSpeak = !this.isSpeak;
      if (this.isSpeak) {
        console.log("开始语音");
        this.voiceFn();
      } else {
        this.releaseResources();
      }
    },
    submitForm() {
      let sendObj = {
        id: this.dlgQuery.cameraId,
        passWord: this.passwordDlgData.password
      };
      checkPassword(sendObj).then(res => {
        if (res.data.code==200) {
          this.verifyPasswordDlg = false
          this.isIntercom();
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg
          });
        }
      });
    },
    resetDlg(){
      if (timer) {
        clearInterval(timer)
        timer = null
        this.countdown = maxCountdown
      }
      this.isSpeak = false;
      player.release()
      this.releaseResources()
    },
    closeDlg() {
      this.$emit("closeDlg");
    }
  }
};
</script>
<style scoped>
.countdown {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translate(-50%, 0);
  color: #333;
  font-size: 20px;
}

.countdown.warning {
  color: #F56C6C;
}
</style>
